import { z } from "zod";

/**
 * EspecificidadeObraSchema
 */

export const EspecificidadeObraSchema = z.object({
  item: z.string().nonempty({ 'message': 'Este campo deve ser preenchido!' }),
  formaControle: z.string().nonempty({ 'message': 'Este campo deve ser preenchido!' }),
});

/**
 * EspecificidadeObraForm
 */

export type EspecificidadeObraForm = z.infer<typeof EspecificidadeObraSchema>;